import { useMutation } from "@tanstack/react-query";
import { api } from "utils/api";

export function useLoanApplicationPdf() {
  return useMutation({
    mutationFn: async (loanId: string): Promise<{ id: number; name: string }> => {
      const response = await api.patch(`/loans/${loanId}/documents/loan-application-pdf`);
      return response.data;
    },
  });
}
